module.exports = __webpack_public_path__ + "img/menu_malin.a153fc47.png";